import {
  ABORT_FETCH,
  ADD_DEPOT,
  CHANGE_EXPORT_COLS,
  DELETE_DEPOT,
  EDIT_DEPOT,
  FETCH_END,
  FETCH_START,
  GROUP_ROUTES_BY_VALUE,
  REMOVE_PROCESS,
  SEEN_PROCESS,
  SET_COMPANY,
  SET_DELIVERY_CATEGORY_TYPES,
  SET_DELIVERY_STATUS_TYPES,
  SET_DEPOTS,
  SET_LOAD_DIMENSION,
  SET_PROCESS,
  SET_OPTIMIZATION_DATA,
  SET_SELECTED_DIMENSION,
  SET_WORKTIME_WINDOW,
  SIDEBAR_TOGGLE,
  SET_INSTANCE,
  SET_USE_TERRITORIES,
  TOGGLE_LOADING,
  SET_SELECTED_PROCESS,
  SET_SELECTED_VERSION,
  SET_SETTINGS,
  SET_PREFILLED_process_id,
  SET_RECENT_PLANNING_DATE,
  SET_ACTIVE_COLS,
  SET_SHIPMENT_SETTINGS,
  UPDATE_TIME_WINDOW, 
  SET_UI_FLAGS,
} from '../types';

// Action type interfaces
interface SetCompanyAction {
  type: typeof SET_COMPANY;
  value: string;
}

interface SetInstanceAction {
  type: typeof SET_INSTANCE;
  data: any;
}

interface SetSelectedProcessAction {
  type: typeof SET_SELECTED_PROCESS;
  data: any;
}

interface SetSelectedVersionAction {
  type: typeof SET_SELECTED_VERSION;
  data: any;
}

interface SetSelectedDimensionAction {
  type: typeof SET_SELECTED_DIMENSION;
  data: number;
}

interface SetUseTerritoriesAction {
  type: typeof SET_USE_TERRITORIES;
  data: boolean;
}

interface StartFetchingAction {
  type: typeof FETCH_START;
}

interface ToggleLoadingAction {
  type: typeof TOGGLE_LOADING;
  data: boolean;
}

interface EndFetchingAction {
  type: typeof FETCH_END;
}

interface AbortFetchingAction {
  type: typeof ABORT_FETCH;
  data: string;
}

interface ChangeExportColumnsAction {
  type: typeof CHANGE_EXPORT_COLS;
  data: any[];
}

interface GroupRoutesByAction {
  type: typeof GROUP_ROUTES_BY_VALUE;
  data: boolean;
}

interface OnAddDepotAction {
  type: typeof ADD_DEPOT;
  data: any;
}

interface OnSetDeliveryCategoryTypesAction {
  type: typeof SET_DELIVERY_CATEGORY_TYPES;
  data: any;
}

interface OnSetDeliveryStatusTypesAction {
  type: typeof SET_DELIVERY_STATUS_TYPES;
  data: any;
}

interface OnEditDepotAction {
  type: typeof EDIT_DEPOT;
  data: any;
}

interface OnDeleteDepotAction {
  type: typeof DELETE_DEPOT;
  data: null;
}

interface SetDepotsAction {
  type: typeof SET_DEPOTS;
  data: any[];
}

interface SetSettingsAction {
  type: typeof SET_SETTINGS;
  data: any;
}

interface SetWorkTimeWindowAction {
  type: typeof SET_WORKTIME_WINDOW;
  start: string;
  end: string;
}

interface SetLoadDimensionAction {
  type: typeof SET_LOAD_DIMENSION;
  data: any;
}

interface EditProcessAction {
  type: typeof SET_PROCESS;
  data: any;
}

interface RemoveProcessAction {
  type: typeof REMOVE_PROCESS;
  data: string;
}

interface ToggleSidebarAction {
  type: typeof SIDEBAR_TOGGLE;
  value: boolean;
}

interface ToggleSeenAction {
  type: typeof SEEN_PROCESS;
  value: boolean;
}

interface SetPrefilledProcessIdAction {
  type: typeof SET_PREFILLED_process_id;
  data: string;
}

// Action type interfaces
interface SetRecentPlanningDate {
  type: typeof SET_RECENT_PLANNING_DATE;
  data: any;
}

// Action type interfaces
interface SetOptimizationData {
  type: typeof SET_OPTIMIZATION_DATA;
  data: any;
}
// Action creators with type annotations

export const setCompany = (address: string): SetCompanyAction => ({
  type: SET_COMPANY,
  value: address
});
export const SetRecentPlanningDate = (data: any): SetRecentPlanningDate => ({
  type: SET_RECENT_PLANNING_DATE,
  data: data
});
export const SetOptimizationData = (data: any): SetOptimizationData => ({
  type: SET_OPTIMIZATION_DATA,
  data: data
});

export const setInstance = (data: any): SetInstanceAction => ({
  type: SET_INSTANCE,
  data: data
});

export const setSelectedProcess = (data: any): SetSelectedProcessAction => ({
  type: SET_SELECTED_PROCESS,
  data: data
});

// Select an optimization version to load (null = latest).
export const setSelectedVersion = (data: any): SetSelectedVersionAction => ({
  type: SET_SELECTED_VERSION,
  data: data
});

export const setSelectedDimension = (index: number): SetSelectedDimensionAction => ({
  type: SET_SELECTED_DIMENSION,
  data: index
});

export const setUseTerritories = (val: boolean): SetUseTerritoriesAction => ({
  type: SET_USE_TERRITORIES,
  data: val
});

export function startFetching (): StartFetchingAction {
  return {
    type: FETCH_START
  };
}

export function toggleLoading (val: boolean): ToggleLoadingAction {
  return {
    type: TOGGLE_LOADING,
    data: val
  };
}

export function endFetching (): EndFetchingAction {
  return {
    type: FETCH_END
  };
}

export function abortFetching (): (dispatch: any) => void {
  return (dispatch) => {
    dispatch({
      type: ABORT_FETCH,
      data: 'Unmount'
    });
  };
}

export function changeExportColumns (cols: any[]): ChangeExportColumnsAction {
  return {
    type: CHANGE_EXPORT_COLS,
    data: cols
  };
}

export function groupRoutesBy (bool: boolean): GroupRoutesByAction {
  return {
    type: GROUP_ROUTES_BY_VALUE,
    data: bool
  };
}

export function onAddDepot (data: any): OnAddDepotAction {
  return {
    type: ADD_DEPOT,
    data
  };
}

export function onSetDeliveryCategoryTypes (data: any): OnSetDeliveryCategoryTypesAction {
  return {
    type: SET_DELIVERY_CATEGORY_TYPES,
    data
  };
}

export function onSetDeliveryStatusTypes (data: any): OnSetDeliveryStatusTypesAction {
  return {
    type: SET_DELIVERY_STATUS_TYPES,
    data
  };
}

export function onEditDepot (data: any): OnEditDepotAction {
  return {
    type: EDIT_DEPOT,
    data
  };
}

export function onDeleteDepot (): OnDeleteDepotAction {
  return {
    type: DELETE_DEPOT,
    data: null
  };
}

export function setDepots (depots: any[]): SetDepotsAction {
  return {
    type: SET_DEPOTS,
    data: depots
  };
}

export function setSettings (settings: any): SetSettingsAction {
  return {
    type: SET_SETTINGS,
    data: settings
  };
}

export function setWorkTimeWindow (start: string, end: string): SetWorkTimeWindowAction {
  return {
    type: SET_WORKTIME_WINDOW,
    start,
    end
  };
}

export function setLoadDimension (dimension: any): SetLoadDimensionAction {
  return {
    type: SET_LOAD_DIMENSION,
    data: dimension
  };
}

export function editProcess (state: any): EditProcessAction {
  return {
    type: SET_PROCESS,
    data: state
  };
}

export function removeProcess (id: string): RemoveProcessAction {
  return {
    type: REMOVE_PROCESS,
    data: id
  };
}

export const toggleSidebar = (state: boolean): ToggleSidebarAction => ({
  type: SIDEBAR_TOGGLE,
  value: state
});

export const toggleSeen = (state: boolean): ToggleSeenAction => ({
  type: SEEN_PROCESS,
  value: state
});

export const setPrefilledProcessId = (id: string): SetPrefilledProcessIdAction => {
  return {
    type: SET_PREFILLED_process_id,
    data: id
  };
};
export const setActiveCols = (cols:any) => ({
  type: SET_ACTIVE_COLS,
  payload: cols,
});
export const setShipmentSettings = (payload:any) => ({
  type: SET_SHIPMENT_SETTINGS,
  payload,
});

export const updateTimeWindow = (section:any, key:any, windowValue:any) => ({
  type: UPDATE_TIME_WINDOW,
  payload: { section, key, windowValue },
});

export const setUI = (flags: string[]) => ({
  type: SET_UI_FLAGS,
  data: flags,
});